export enum BadmintonGameType {
    RALLY = "RALLY"
}
export enum BadmintonGameFormat {
    WIN_BY_2 = "WIN_BY_2"
}
